<template>
  <div>
    <v-lp-tool-bar/>
    <v-img
      :src="mainImage"
      gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.7)"
      :height="500"
    >
      <v-container
        fill-height
        class="main--text"
      >
        <v-row
          justify=end
          align=center
        >
          <v-col
            cols=12
            md=6
          >
            <h3
              class="white--text"
            >自宅で始める<br>プログラミング学習</h3>
            <br>
            <h1
              :class="headingStyle"
            >
              無料体験<br>受付中
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <v-sheet>
      <v-container
        class=main--text
        fluid>
        <!-- （導入） -->
        <v-row
          justify=center>
          <v-col
            cols=auto>
            <h1>子どものプログラミング教室って、どう選べば良いの…？</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols=12
            sm=6>
            <v-img
              :src="introImage"
              :aspect_ratio="9/16"
              height=400>
            </v-img>
          </v-col>
          <v-col
            cols=12
            sm=6>
              <v-row>
                <ul class="trouble--list">
                  <li>近くに良さそうな教室がなくて…</li>
                  <li>本当に将来役に立つの…？</li>
                  <li>ちゃんと身につくか不安…</li>
                  <li>送り迎えが大変じゃ…</li>
                </ul>
              </v-row>
              <v-row
                justify=center>
                <v-col
                  cols=auto
                  >
                  <h1 class="emphasis--phrase">Prosenseに</h1>
                </v-col>
              </v-row>
              <v-row
                justify=center
                >
                <v-col
                  cols=auto
                  class="no--vertical--paddings">
                  <h1 class="emphasis--phrase">お任せください！</h1>
                </v-col>
              </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-to-application-icon
      :buttonID="0"
      @jump-button-clicked="sendJumpEventLog"/>
    <v-section-bar
      message="身につくチカラ"/>
    <v-container
      fluid
      class=main--text>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=8>
          <v-what-to-learn-card/>
        </v-col>
      </v-row>
    </v-container>
    <v-to-application-icon
      :buttonID="1"
      @jump-button-clicked="sendJumpEventLog"/>
    <v-section-bar
      message="Prosenseの強み"/>
    <v-container
      class="main--text"
      fluid>
      <v-row>
        <v-col
          cols=12
          md=6>
          <v-container
            fluid>
            <v-row
              justify=center>
              <v-col
                cols=auto>
                <h2 class="emphasis--phrase">ブラウザで簡単にスタート</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols=12>
                <v-img
                  :src="editorImage"></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols=12
          md=6>
          <v-container
            fluid>
            <v-row
              justify=center>
              <v-col
                cols=auto>
                <h2 class="emphasis--phrase">一対一の個別指導</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols=12>
                <v-img
                  :src="videoImage"></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-strong-point-cards/>
    <v-to-application-icon
      :buttonID="2"
      @jump-button-clicked="sendJumpEventLog"/>
    <v-section-bar
      message="講師紹介"/>
    <v-container
      fluid>
      <v-row
        justify=center
        >
        <v-col
          cols=12
          md=10>
          <v-teacher-profile-carousel/>
        </v-col>
      </v-row>
    </v-container>
    <v-to-application-icon
      :buttonID="3"
      @jump-button-clicked="sendJumpEventLog"/>
    <v-section-bar
      message="体験授業までの流れ"/>
    <v-sheet
      class=main--text>
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-timeline
              :dense="$vuetify.breakpoint.smAndDown">
              <v-timeline-item
                icon="far fa-paper-plane">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      justify=center
                      no-gutters>
                      <v-col
                        cols=auto>
                        <h2><a
                          href="/lp/application-form">
                          専用フォーム</a>からお申し込み
                        </h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                icon="fa-calendar-alt">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      no-gutters
                      justify=center>
                      <v-col
                        cols=auto>
                        <h2>担当講師と日程を調整</h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                icon="fa-chalkboard-teacher">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      no-gutters
                      justify=center>
                      <v-col
                        cols=auto>
                        <h2>体験授業を受講！</h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-stepper
              vertical
              alt-labels
              non-liner
              >
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h2>カリキュラム</h2>
                </v-col>
              </v-row>
              <v-stepper-step
                complete
                step=1>
                自己紹介＆プログラミングとは
                <small>所要時間：約10分</small>
              </v-stepper-step>
              <v-stepper-step
                complete
                step=2>
                プログラミングレッスン
                <small>所要時間：約30分</small>
              </v-stepper-step>
              <v-stepper-step
                complete
                step=3>
                振り返り＆保護者様向けご説明
                <small>所要時間：約20分</small>
              </v-stepper-step>
            </v-stepper>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-img :src="trialImage"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-to-application-icon
      :buttonID="4"
      @jump-button-clicked="sendJumpEventLog"/>
    <v-section-bar
      message="保護者の方からの声"/>
    <v-sheet
      class="main--text">
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            sm=10
            md=8>
            <v-users-voices/>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-to-application-icon
      :buttonID="5"
      @jump-button-clicked="sendJumpEventLog"/>
    <v-section-bar
      message="よくあるご質問"/>
    <v-q-and-a-cards/>
    <v-to-application-icon
      :buttonID="6"
      @jump-button-clicked="sendJumpEventLog"/>
    <v-section-bar
      message="サービス保証"/>
    <v-container
      class=main--text
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=6>
          <v-card>
            <v-img
              :src="motherAndDaughterImage"/>
            <v-container
              fluid>
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h3>受講開始から１ヶ月間について</h3>
                </v-col>
              </v-row>
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h3>授業内容にご満足いただけなかった場合</h3>
                </v-col>
              </v-row>
              <v-row
                justify=center>
                <v-col
                  cols=auto
                  class="red--text">
                  <h2>授業料を全額返金します</h2>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-to-application-icon
      :buttonID="7"
      @jump-button-clicked="sendJumpEventLog"/>
    <v-section-bar
      message="体験のお申し込み"
      id="what-is-prosense-2-application-form"/>
    <v-container
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=8
          >
          <v-application-card
            v-model="inputValue"
            @submit-button-click="submitApplication"/>
        </v-col>
      </v-row>
    </v-container>
    <v-footer
    height="auto"
    color="primary"
    >
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=3
            sm=3
            offset-sm=1
            md=2
            offset-md=4>
            <v-img
              :src="nucoLogo"/>
          </v-col>
          <v-col
            class="main--text white--text"
            cols=9
            sm=6>
            <h3>株式会社Nuco</h3>
            <span>東京都渋谷区東1-26-20<br>東京建物東渋谷ビル 6F</span><br>
            <span>代表：小山内美悠</span><br>
            <span>営業：平日10:00-19:00</span>
          </v-col>
        </v-row>
        <v-row
          justify=space-between>
          <v-col
            py-3
            class=white--text
            cols=auto
            >
            &copy;2019 — <strong>Prosense</strong>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-dialog
      v-model="submitedDialog"
      max-width=400
      persistent>
      <v-card
        class="main--text">
        <v-container>
          <v-card-title
            >
            お申し込みが完了しました
          </v-card-title>
          <v-card-text>
            通常１営業日以内に、担当講師よりメールにてご連絡いたします。
          </v-card-text>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                @click="closeSubmitedDialog"
                outlined
                rounded
                color=primary>
                閉じる
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="errorDialog"
      max-width=450
      persistent>
      <v-card
        class="main--text">
        <v-container
          fluid>
          <v-card-title
            class="red--text">
            サーバー内部エラーが発生しました
          </v-card-title>
          <v-card-text>
            申し訳ございませんが、しばらくの後、改めてご利用ください
          </v-card-text>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                @click="closeErrorDialog"
                outlined
                rounded
                color=primary>
                閉じる
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainImage from '@/assets/img/main_image.jpg'
import IntroImage from '@/assets/img/introduction_trouble.jpg'
import TrialImage from '@/assets/img/trial.jpg'
import EditorImage from '@/assets/img/editor.jpg'
import VideoImage from '@/assets/img/video.jpg'
import NucoLogo from '@/assets/img/nuco_logo.png'
import MotherAndDaughterImage from '@/assets/img/mother_and_daughter.jpg'
import VLpToolBar from '@/components/organisms/lp/VLpToolBar.vue'
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VLpFooter from '@/components/organisms/lp/VLpFooter.vue'
import VToApplicationIcon from '@/components/organisms/lp/VToApplicatonIcon.vue'
import VApplicationCard from '@/components/organisms/lp/VApplicationCard.vue'
import VWhatToLearnCard from '@/components/organisms/lp/VWhatToLearnCard.vue'
import VUsersVoices from '@/components/organisms/lp/VUsersVoices.vue'
import VQAndACards from '@/components/organisms/lp/VQAndACards.vue'
import VStrongPointCards from '@/components/organisms/lp/VStrongPointCards.vue'
import VTeacherProfileCarousel from '@/components/organisms/lp/VTeacherProfileCarousel.vue'
import { TrialApplicationRepository } from '@/repository/TrialApplicationRepository'
import { firestore } from '@/repository/client/firestore'
import { app } from '@/core/firebase'

export default {
  components: {
    VLpToolBar,
    VLpFooter,
    VSectionBar,
    VToApplicationIcon,
    VApplicationCard,
    VWhatToLearnCard,
    VUsersVoices,
    VQAndACards,
    VStrongPointCards,
    VTeacherProfileCarousel
  },
  data: () => {
    return {
      analytics: null,
      mainImage: MainImage,
      introImage: IntroImage,
      trialImage: TrialImage,
      editorImage: EditorImage,
      videoImage: VideoImage,
      nucoLogo: NucoLogo,
      motherAndDaughterImage: MotherAndDaughterImage,
      inputValue: {opinion: ""},
      submitedDialog: false,
      errorDialog: false
    }
  },
  methods: {
    async submitApplication() {
      try {
        const applyRepo = new TrialApplicationRepository(firestore)
        const application = await applyRepo.put({
          parentName: this.inputValue.parentName,
          email: this.inputValue.email,
          studentName: this.inputValue.studentName,
          studentAge: this.inputValue.studentAge,
          opinion: this.inputValue.opinion
        })
        this.submitedDialog = true
      } catch (e) {
        this.errorDialog = true
      }
    },
    closeSubmitedDialog() {
      this.submitedDialog = false
    },
    closeErrorDialog() {
      this.errorDialog = false
    },
    sendJumpEventLog(buttonID) {
      this.analytics.logEvent(
        'to_application_form',
        {
          button_id: buttonID
        }
      )
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    headingStyle () {
      return (this.isMobile) ? 'heading-text-mobile' : 'heading-text'
    }
  },
  created () {
    this.analytics = app.analytics()
  }
}
</script>

<style scoped>
.heading-text {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size:5.0rem;
  letter-spacing:5px;
}

.heading-text-mobile {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size:3.5rem;
  letter-spacing:3px;
}

.no--vertical--paddings {
  padding: 0px 12px;
}

.trouble--list li {
  margin: 0px 0px 10px 10px;
  font-weight: bold;
  font-size: 1.4rem;
  color: brown
}

.emphasis--phrase {
  background: linear-gradient(transparent 60%, #ffff66 60%)
}

</style>

